/*
 * Fund header control
*/

rs.module("applicationmenu/fund/header",

    ["ui/framework/client-templates"],

    function (clientTemplates) {

        var _jsSelectors;
        var _clientTemplateKeys;
        var _navBoard;
        var _navBoardChildren;
        var _searchControl;

        // Initialize the module
        function initialize(jsSelectors, clientTemplateKeys, multipleFunds) {

            // All of this is only necessary if there are multiple funds
            if (multipleFunds) {

                _jsSelectors = jsSelectors;
                _clientTemplateKeys = clientTemplateKeys;

                var searchButton = $.js(jsSelectors.searchButton);

                _navBoard = searchButton.closest($.js(jsSelectors.navBoard, { multiple: true }));
                _navBoardChildren = _navBoard.children().not($.js(jsSelectors.navBoardTitle, { multiple: true }));

                searchButton.on("click", _onClickSearch);

                // Add the search template to the DOM when the header is intialized.
                _searchControl = $(clientTemplates.render(_clientTemplateKeys.searchTemplate));
                _navBoard.append(_searchControl);
            }
        }

        // The search button has been clicked
        function _onClickSearch() {

            _navBoardChildren.hide();

            _searchControl.fadeIn("fast");
            _searchControl.find("input").focus();

            _searchControl.js(_jsSelectors.searchBack).on("click", _onClickSearchExit);
        }

        // Exiting the search
        function _onClickSearchExit() {

            _searchControl.hide();

            _navBoardChildren.fadeIn("fast");
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);